module.exports = __webpack_public_path__ + "static/media/facing.fc435972.png";